module.exports = __webpack_public_path__ + "static/media/400067_02.20764b8f.png";